import React from "react";
import Pointer from "./pointer";

let NotFound = () => (
  <div className="App-body textNoCursor">
    <div>Page not found.</div>
    <div>Why dont you have a look in the sidebar...</div>
    <Pointer />
  </div>
);

export default NotFound;
